import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiAccordion from "components/Custom/UiAccordion";
import UiDialog from "../../Custom/UiDialog";
import AddSalesInvoice from "../AddSalesInvoice";
import OrderSummaryPrint from "../SalesReturn/print/OrderSummaryPrint";
import SalesReturnBillPrint from "./print/SalesReturnBillPrint";
import SalesReturnSkeleton from "./SalesReturnSkeleton";

import { LABELS, TITLES, WARNINGS } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";

import { DEFAULTS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { PRODUCT_APIs } from "apihandlers/product";
import { USER_APIs } from "apihandlers/user";
import { TRANS_APIs } from "apihandlers/transaction";
import { GEO_APIs } from "apihandlers/geography";
import {ORDER_APIs} from "apihandlers/order"
import { CUSTOMER_APIs } from "apihandlers/customer";

const SalesReturn = (props: any) => {
  const { setDashMenu } = props;

  const productRef: any = useRef(null);
  const userRef: any = useRef(null);
  const areasRef: any = useRef(null);
  const salesReturnRef: any = useRef(null);
  const partyRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState<any>({});
  const [rows, setRows] = useState<any>(null);
  const [subRows, setSubRows] = useState<any>([]);
  const [resetUsers, setResetUsers] = useState<any>({
    id: "",
    label: "Select User",
  });
  const [resetRoute, setResetRoute] = useState<any>({
    id: "",
    label: "Select Route",
  });
  const [resetFormDate, setResetFormDate] = useState<any>(
    DateFunctions.getDate("2days", "from", "YYYY-MM-DD")
  );
  const [resetToDate, setResetToDate] = useState<any>(
    DateFunctions.getDate("today", "to", "YYYY-MM-DD")
  );
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [products, setProducts] = useState<any>({});
  const [areas, setAreas] = useState<any>({});
  const [resetArgs, setResetArgs] = useState<any>({});
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [managePrintDialog, setManagePrintDialog] = useState<boolean>(false);
  const [manageReturnPrintDialog, setManageReturnPrintDialog] =
    useState<boolean>(false);

  const [parties, setParties] = useState<any>({});
  const [users, setUsers] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const columns = [
    {
      key: "",
      selectColumn: true,
    },
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "orderNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.BILL_NO,
      width: "10%",
    },
    {
      key: "salesReturnNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SALES_RETURN_NO,
      width: "15%",
    },
    {
      key: "salesReturnDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SALES_RETURN_DATE,
      width: "10%",
    },
    {
      key: "shopName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SHOP_NAME,
      width: "20%",
    },
    {
      key: "routeName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ROUTE_NAME,
      width: "20%",
    },
    {
      key: "totalQty",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ITEMS,
      width: "10%",
    },
    {
      key: "total",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.AMOUNT,
      width: "10%",
    },
  ];

  useEffect(() => {
    if (loading) {
      getRoute();
    }
  }, [loading]);

  const getRoute = () => {
    const args = {
      activeStatus: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setAreas(list);
        getUser();
      }
    });
  };

  const getUser = () => {
    const args = {
      activeStatus: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setUsers(list);
        getRows();
      }
    });
  };

  const getRows = async () => {
    try {
      const fromDate = (
        document.getElementById("fromDate") as HTMLInputElement
      ).value.trim();
      const toDate = (
        document.getElementById("toDate") as HTMLInputElement
      ).value.trim();
      // const routeId = areasRef.current.selectedValue.id;
      // const userId = userRef.current.selectedValue.id;
      const args = {
        isReturn: "true",
        isSale: "true",
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
        fromDate: fromDate,
        toDate,
        routeId: resetRoute.id,
        userId: resetUsers.id,
      };
      setRows(null);
      console.log("args", args);
      const res: any = await ORDER_APIs.getOrders(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getSalesReturn:", error);
    }
  };

  const userChange = (e, val) => {
    setResetUsers(val);
  };
  const routeChange = (e, val) => {
    setResetRoute(val);
  };
  const onFromDateChange = (e) => {
    setResetFormDate(e.target.value);
  };
  const onToDateChange = (e) => {
    setResetToDate(e.target.value);
  };
  const onReset = () => {
    setResetFormDate(DateFunctions.getDate("today", "from", "YYYY-MM-DD"));
    setResetToDate(DateFunctions.getDate("thismonth", "to", "YYYY-MM-DD"));
    setResetUsers({ id: "", label: "Select User" });
    setResetRoute({ id: "", label: "Select Route" });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const printSummary = () => {
    const orderRow = salesReturnRef.getSelectedRows();
    if (orderRow.length === 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManagePrintDialog(true);
      if (managePrintDialog === true) {
        const html = document.getElementById("returnSummary").innerHTML;
        COMMON_JS.printHtml(html);
      }
    }
  };

  const printSalesReport = (e) => {
    const orderRow = salesReturnRef.getSelectedRows();
    if (orderRow.length === 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        "Please select atleast one Order!..."
      );
    } else {
      setManageReturnPrintDialog(true);
      if (manageReturnPrintDialog === true) {
        const html = document.getElementById("salesReturnBill").innerHTML;
        COMMON_JS.printHtml(html);
      }
    }
  };
  console.log("filter", resetUsers);

  return (
    <React.Fragment>
      {
        <div className="pageInfo">
          <ul className="breadcrumbs">
            <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.HOME}</li>
            <li className="dim">{" / "}</li>
            <li onClick={() => props.setDashMenu(LABELS.HOME)}>
              {LABELS.SALES}
            </li>
            <li className="dim">{" / "}</li>
            <li className="active">{TITLES.SALES_RETURN}</li>
          </ul>
          <h4>{TITLES.SALES_RETURN}</h4>
        </div>
      }
      <div className=" filterBorder" style={{ width: "96%" }}>
        <UiAccordion id={"filter"} title={LABELS.FILTER}>
          <div className="flexRowAround">
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.FROM_DATE}
                type={"date"}
                id="fromDate"
                value={resetFormDate}
                onChange={onFromDateChange}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.TO_DATE}
                type={"date"}
                id="toDate"
                value={resetToDate}
                onChange={onToDateChange}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.ROUTE}</label>
              <AutoComplete
                list={areas}
                childRef={areasRef}
                inputValue={resetRoute}
                onChange={routeChange}
              />
            </div>
          </div>
          <div className="flexRowAround" style={{ margin: 0, padding: 0 }}>
            <div className="formGroup width30">
              <label>{LABELS.USER}</label>
              <AutoComplete
                list={users}
                childRef={userRef}
                inputValue={resetUsers}
                onChange={userChange}
              />
            </div>
            <div className="formGroup width30"></div>
            <div className="formGroup width30">
              <div className="flexbtnLoad " style={{ marginTop: "1.5rem" }}>
                <Btn
                  text={LABELS.RESET}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={onReset}
                  //loading={isSubmit}
                />
                <Btn
                  text={LABELS.LOAD}
                  onClick={getRows}
                  bgColor={COLORS.GRID_ADD_NEW}
                  // loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiAccordion>
      </div>

      {rows ? (
        <div className="grid excelGridWrapper">
          <ExcelGrid
            id={"salesReturn"}
            childRef={salesReturnRef}
            height={window.innerHeight * 0.55}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.SALES_RETURN}
            onReload={reloadGrid}
            leftSideWidth={"50%"}
            rightSideWidth={"50%"}
            leftSideBtns={
              <>
                <div className="excelBtnWrapper">
                  <Btn
                    text={LABELS.PRINT_SUMMARY}
                    onClick={printSummary}
                    bgColor={COLORS.GRID_HEADER}
                    color={COLORS.RELOAD_EXPORT_TEXT}
                  />
                </div>
                <div className="excelBtnWrapper">
                  <Btn
                    text={LABELS.PRINT_SALES_RETURN}
                    onClick={printSalesReport}
                    bgColor={COLORS.GRID_HEADER}
                    color={COLORS.RELOAD_EXPORT_TEXT}
                  />
                </div>
              </>
            }
          />
        </div>
      ) : (
        <SalesReturnSkeleton />
      )}

      {managePrintDialog && (
        <UiDialog
          title={LABELS.RETURN_SUMMARY + ": "}
          open={true}
          size={"md"}
          onClose={() => {
            setManagePrintDialog(false);
          }}
        >
          <div style={{ height: "100%" }}>
            <div
              style={{
                height: "70%",
                overflow: "auto",
                marginBottom: "1.5rem",
              }}
            >
              <OrderSummaryPrint salesReturnRef={salesReturnRef} />
            </div>
            <div
              style={{
                margin: "0.5rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "right",
                width: "95%",
                zIndex: 999,
                position: "fixed",
                bottom: 0,
              }}
            >
              <div
                style={{
                  width: "35%",
                  display: "flex",
                  justifyContent: "right",
                }}
              >
                <Btn
                  text={LABELS.PRINT_SUMMARY}
                  onClick={printSummary}
                  marginRight={15}
                  bgColor={COLORS.GRID_ADD_NEW}
                  //  loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}

      {manageReturnPrintDialog && (
        <UiDialog
          title={LABELS.SALES_RETURN + ": "}
          open={true}
          size={"md"}
          onClose={() => {
            setManageReturnPrintDialog(false);
          }}
        >
          <div style={{ height: "100%" }}>
            <div
              style={{
                height: "70%",
                overflow: "auto",
                marginBottom: "1.5rem",
              }}
            >
              <SalesReturnBillPrint salesReturnRef={salesReturnRef} />
            </div>
            <div
              style={{
                margin: "0.5rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "right",
                width: "95%",
                zIndex: 999,
                position: "fixed",
                bottom: 0,
              }}
            >
              <div
                style={{
                  width: "35%",
                  display: "flex",
                  justifyContent: "right",
                }}
              >
                <Btn
                  text={LABELS.PRINT_SUMMARY}
                  onClick={printSalesReport}
                  marginRight={15}
                  bgColor={COLORS.GRID_ADD_NEW}
                  //  loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(SalesReturn);
